export class ContributorIdentityFileModel {
    public id: number;
    public fileName: string;
    public type: number;
    public url: number;
}
